export function getModalContentFullScreenHeight(element) {
  return getComputedStyle(element).getPropertyValue(
    '--modal-content-fullscreen-height'
  )
}
